module.exports = __webpack_public_path__ + "static/media/logo-title.0c10e641.png";